import { useState, useRef } from 'react';
import { DatePicker, Input, Modal, Radio, Space } from 'antd';
import XTable from 'components/XTable';
import XForm from 'components/XForm';
import {
    getVistRecordListApi,
    getDownloadApi,
    getUserByIdNoApi,
    postRegistrationApi,
} from 'api/checkInRecord';
import { getFilterText, downFile, getIdCardInfo } from 'utils';
import { nursingAreas } from 'enumeration/nursingAreas';
import moment from 'moment';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
// 申请时间大于17:30 可约后天以后时间 17:30约明天
const tiem1730 = `${dayjs().format('YYYY-MM-DD')} 17:30:00`;

const VisitRecord = () => {
    const xTableRef = useRef();
    const xFormRef = useRef();
    const [editVisible, seteditVisible] = useState(false);
    const [editLoading, seteditLoading] = useState(false);

    const [checkRecordId, setcheckRecordId] = useState('');
    const [nursingArea, setnursingArea] = useState('');

    const formTailLayout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    const downloadRecord = () => {
        const queryValue = xTableRef.current.queryForm?.getFieldsValue();
        const params = handelParams(queryValue);
        getDownloadApi(params).then(res => {
            if (res.success) {
                const filename = `来访记录${moment().valueOf()}.xls`;
                downFile(res.file, filename);
            }
        });
    };

    const columns = [
        {
            title: '来访者姓名',
            dataIndex: 'visitName',
        },
        {
            title: '来访日期',
            dataIndex: 'visitDate',
            render: val => (val ? moment(val).format('YYYY-MM-DD') : '-'),
        },
        {
            title: '来访者手机',
            dataIndex: 'visitCellphone',
        },
        {
            title: '申请时间',
            dataIndex: 'createAt',
            render: val => (val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '-'),
        },
        {
            title: '探访地点',
            dataIndex: 'address',
        },
        {
            title: '被访者姓名',
            dataIndex: 'name',
        },
        {
            title: '被访者所在区域',
            dataIndex: 'nursingArea',
            render: val => getFilterText(nursingAreas, val),
        },
        {
            title: '来访者与被访者关系',
            dataIndex: 'relate',
        },
        {
            title: '被访者身份证',
            dataIndex: 'idNo',
        },
        {
            title: '后台提交',
            dataIndex: 'isBackstage',
            render: val => (val ? '是' : '否'),
        },
        {
            title: '备注',
            dataIndex: 'remark',
        },
    ];

    const queryItems = [
        {
            formItemApis: {
                label: '来访者手机',
                help: null,
                name: 'visit_cellphone',
            },
            item: <Input style={{ width: 150 }} allowClear />,
        },
        {
            formItemApis: {
                label: '被访者姓名',
                help: null,
                name: 'name',
            },
            item: <Input style={{ width: 150 }} allowClear />,
        },
        {
            formItemApis: {
                label: '来访日期',
                help: null,
                name: 'visitDateRange',
            },
            item: (
                <RangePicker
                    format="YYYY-MM-DD"
                    defaultValue={
                        tiem1730
                            ? new Date(dayjs().add(2, 'days'))
                            : new Date(dayjs().add(1, 'days'))
                    }
                />
            ),
        },
    ];

    const handelParams = params => {
        const { visitDateRange, ...otherParams } = params;
        let beginDate = '';
        let endDate = '';
        let newParams = otherParams;
        if (visitDateRange && visitDateRange.length) {
            beginDate = moment(visitDateRange[0]).format('YYYY-MM-DD');
            endDate = moment(visitDateRange[1]).format('YYYY-MM-DD');
            newParams = { ...otherParams, beginDate, endDate };
        }
        return newParams;
    };
    const editModalShow = () => {
        seteditVisible(true);
    };

    const actionBtns = [
        { text: '新增来访记录', onClick: editModalShow },
        { text: '导出申请记录', onClick: downloadRecord },
    ];

    // 确认修改
    const editOk = () => {
        xFormRef.current.form?.submit();
    };

    const getIdInfo = async (_, value) => {
        if (value) {
            const idInfo = getIdCardInfo(value);
            const { success } = idInfo;
            if (success) {
                const userRes = await getUserByIdNoApi({ idNo: value });
                const { age, name, nursingArea, success, id } = userRes || {};
                if (success) {
                    const nursingAreaText =
                        (nursingAreas.find(item => item.value === nursingArea) || {}).text ||
                        nursingArea;
                    xFormRef.current.form?.setFieldsValue({
                        age,
                        name,
                        nursingArea: nursingAreaText,
                    });
                    setnursingArea(nursingArea);
                    setcheckRecordId(id);
                    return Promise.resolve();
                } else {
                    reSetIdNoFromItems();
                    return Promise.reject(new Error('未查询到对应入住人员，请确认。'));
                }
            } else {
                reSetIdNoFromItems();
                return Promise.reject(new Error('请输入正确的身份证号'));
            }
        } else {
            reSetIdNoFromItems();
            return Promise.reject(new Error('请输入身份证号'));
        }
    };

    // 错误身份证号，重置数据
    const reSetIdNoFromItems = () => {
        xFormRef.current.form?.setFieldsValue({
            age: '',
            name: '',
            nursingArea: '',
        });
        setcheckRecordId('');
    };

    const onCancel = () => {
        xFormRef.current.form?.setFieldsValue({
            idNo: '',
            age: '',
            name: '',
            visitName: '',
            nursingArea: '',
            relate: '',
            address: '',
            visitCellphone: '',
            total: 0,
            reserved: 0,
            remark: '',
            visitDate: '',
        });
        setcheckRecordId('');
        seteditVisible(false);
    };

    // 执行床位变更
    const onFinish = values => {
        seteditLoading(true);
        const { address, relate, remark, visitCellphone, visitDate, visitName, idNo } = values;
        const params = {
            address,
            checkRecordId,
            relate,
            remark,
            visitCellphone,
            visitDate: dayjs(visitDate).format('YYYY-MM-DD'),
            visitName,
            area: nursingArea,
            idNo,
            isBackstage: true,
        };
        postRegistrationApi(params).then(res => {
            seteditLoading(false);
            if (res.success) {
                onCancel();
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
        });
    };

    const formItems = [
        {
            formItemApis: {
                label: '入住人员身份证号',
                help: null,
                name: 'idNo',
                rules: [
                    { required: true, message: '身份证号码不能为空' },
                    { validator: getIdInfo },
                ],
            },
            item: <Input placeholder="请输入入住人员身份证号码" />,
        },
        {
            formItemApis: {
                label: '入住人员姓名',
                help: null,
                name: 'name',
            },
            item: <Input disabled />,
        },
        {
            formItemApis: {
                label: '入住人员年龄',
                help: null,
                name: 'age',
            },
            item: <Input disabled />,
        },
        {
            formItemApis: {
                label: '入住区域',
                help: null,
                name: 'nursingArea',
            },
            item: <Input disabled />,
        },
        {
            formItemApis: {
                label: '探访者姓名',
                help: null,
                name: 'visitName',
                rules: [{ required: true, message: '探视人姓名不能为空' }],
            },
            item: <Input placeholder="请输入视人姓名" allowClear />,
        },
        {
            formItemApis: {
                label: '探访者手机',
                help: null,
                name: 'visitCellphone',
                rules: [{ required: true, message: '探访者手机不能为空' }],
            },
            item: <Input placeholder="请输入手机号" maxLength={11} />,
        },
        {
            formItemApis: {
                label: '与探访者关系',
                help: null,
                name: 'relate',
                rules: [{ required: true, message: '与探访者关系不能为空' }],
            },
            item: <Input placeholder="请输入与入住人员关系" />,
        },
        {
            formItemApis: {
                label: '探视区域',
                help: null,
                name: 'address',
                rules: [{ required: true, message: '探视区域不能为空' }],
            },
            item: (
                <Radio.Group>
                    <Space direction="vertical">
                        <Radio value="自理区老人：一号楼一层阅览室">
                            自理区老人：一号楼一层阅览室
                        </Radio>
                        <Radio value="半失能老人:半护理区护理站大厅">
                            半失能老人：半护理区护理站大厅
                        </Radio>
                        <Radio value="失能老人：全护理区护理站大厅">
                            失能老人：全护理区护理站大厅
                        </Radio>
                    </Space>
                </Radio.Group>
            ),
        },
        {
            formItemApis: {
                name: 'visitDate',
                label: '探视日期',
                rules: [{ required: true, message: '探视日期不能为空' }],
                help: null,
            },
            item: <DatePicker format="YYYY/MM/DD" />,
        },
        {
            formItemApis: {
                name: 'remark',
                label: '备注',
                help: null,
            },
            item: <Input placeholder="请输入备注" />,
        },
    ];
    return (
        <div>
            <XTable
                columns={columns}
                handelParams={handelParams}
                queryItems={queryItems}
                actionBtns={actionBtns}
                api={getVistRecordListApi}
                rowKey="id"
                ref={xTableRef}
            />
            <Modal
                title="来访登记"
                centered
                wrapClassName="modalBox"
                visible={editVisible}
                onOk={editOk}
                okButtonProps={{ loading: editLoading }}
                onCancel={onCancel}>
                <XForm
                    formApis={{
                        ...formTailLayout,
                        name: 'editBad',
                        onFinish: onFinish,
                    }}
                    formItems={formItems}
                    ref={xFormRef}
                />
            </Modal>
        </div>
    );
};
export default VisitRecord;
